import { Navigate, Outlet } from 'react-router-dom';
import { useShellAside } from '../../layout/ShellAside';
import { useCanVerify } from '../../store/api/paymentVerificationApi';
import VerificationAside from './VerificationAside';
import './VerificationLayout.scss';

/**
 * Layout route for `/verification/*`. Hangs the section aside on the shell, as
 * AffiliateLayout does. Each page reads its own endpoint — payment
 * (`/v2/get/payment-verification/`), Veriff (`/v3/get/kyc/status/`), documents
 * (`/v1/kyc-verification/status/`) and contracts (`/v3/get/contract/user-list/`)
 * — so opening one section doesn't fetch the other three.
 */
export default function VerificationLayout() {
  useShellAside(() => <VerificationAside />, []);
  const { ready, canVerify } = useCanVerify();

  // The whole section only for a trader the backend lets verify (`can_verify`),
  // as the old dashboard showed its Verification tab. A link in from elsewhere
  // (the payout checklist, an old bookmark) lands on the dashboard instead.
  if (ready && !canVerify) return <Navigate to="/dashboard" replace />;

  return <div className="pv">{ready && <Outlet />}</div>;
}
